export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            关于糖心
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              糖心影视是一个专注于高清影视资源聚合的免费在线观看平台。自上线以来，我们始终秉持"即点即播，甜蜜观影"的理念，致力于为每一位影迷提供最便捷、最流畅的在线观影体验。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              糖心影视网站涵盖最新电影、热播电视剧、热门综艺、经典动漫、高分纪录片等全品类内容，资源丰富且每日更新。无论是追剧党、电影发烧友还是偶尔放松的普通观众，都能在糖心影视平台找到心仪的影片。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              我们深知流畅的播放体验对用户的重要性。糖心影视团队持续优化平台技术，确保高清画质下的稳定播放，让每一位访问糖心影视网站的用户都能享受纯粹的观影乐趣。
            </p>
            <div className="mt-6 flex flex-wrap gap-4">
              <span className="px-4 py-1.5 text-xs font-medium bg-primary-100 text-primary-700 rounded-full whitespace-nowrap">海量资源</span>
              <span className="px-4 py-1.5 text-xs font-medium bg-accent-100 text-accent-700 rounded-full whitespace-nowrap">免费观看</span>
              <span className="px-4 py-1.5 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full whitespace-nowrap">高清画质</span>
              <span className="px-4 py-1.5 text-xs font-medium bg-primary-100 text-primary-700 rounded-full whitespace-nowrap">每日更新</span>
            </div>
          </div>

          <div className="flex-shrink-0 w-full max-w-[380px]">
            <div className="relative rounded-2xl overflow-hidden bg-background-200 aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=A%20cinematic%20home%20theater%20atmosphere%20with%20warm%20ambient%20lighting%2C%20abstract%20geometric%20shapes%20evoking%20film%20screens%2C%20soft%20coral%20and%20gold%20gradient%20background%2C%20elegant%20minimal%20aesthetic%2C%20cozy%20entertainment%20vibe%2C%20no%20text%20no%20people&width=760&height=570&seq=about-visual-001&orientation=landscape"
                alt="关于糖心影视平台"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}